import BurgerMenu from './burgerMenu';

function AppLayout({ children, fitViewport = false }) {
  return (
    <div className={`${fitViewport ? 'h-[100dvh] overflow-hidden' : 'min-h-screen'} bg-[#eef4fb] text-gray-950`}>
      <BurgerMenu />
      <main className={`mx-auto flex w-full max-w-6xl flex-col justify-start px-3 sm:px-5 lg:px-8 ${
        fitViewport
          ? 'h-full overflow-hidden py-[clamp(0.5rem,1.5dvh,1.5rem)]'
          : 'min-h-screen py-10 sm:py-12'
      }`}>
        {children}
      </main>
    </div>
  );
}

export default AppLayout;
